import { ListItem } from "../models/listItem";

export const paymentOptionTypes: ListItem[] = [
    {
        text: 'Checking ACH',
        value: '1',
    },
    {
        text: 'Savings ACH',
        value: '2',
    },
    {
        text: 'Payment Card',
        value: '3',
    },
    {
        text: 'Physical Check',
        value: '4',
    },
];

export const directDepositType: ListItem[] = [
    {
        text: 'Checking ACH',
        value: '1',
    },
    {
        text: 'Savings ACH',
        value: '2',
    },
];
